<lib-speed-monitor [mode]="screenMode" [workCenterId]="workCenterId" [kpisList]="kpisList" [displayTime]="displayTime"></lib-speed-monitor>
